<template>
	<p class="text-lg font-bold"><slot/></p>
</template>
<script setup lang="ts"></script>